module.exports = __webpack_public_path__ + "static/HF_XJSSC-880f5c9c59ef9f047af034a9f9dc0ff3.png";